import { QuickstartThankYouRedirect } from './QuickstartThankYouRedirect';
import { QuickstartTheme } from '../types/theme';

interface QuickstartErrorProps {
  theme: QuickstartTheme;
  urlSlug: string;
  hasSlugConfig: boolean;
  message?: string;
  onRetry?: () => void;
  onWishlistCTAClicked?: () => void;
}

/**
 * QuickstartError Component
 *
 * Pure leaf component that renders the thank you/redirect page for errors.
 * Auto-redirect routing is handled by the coordinator, not this component.
 */
export const QuickstartError = ({ theme, urlSlug, hasSlugConfig, onWishlistCTAClicked }: QuickstartErrorProps) => {
  return (
    <QuickstartThankYouRedirect
      theme={theme}
      urlSlug={urlSlug}
      hasSlugConfig={hasSlugConfig}
      onRedirect={onWishlistCTAClicked}
    />
  );
};

